import React, { useCallback } from 'react';
import { useGetUniverseTemplate } from 'src/hooks/use-get-universe-template';
import { SvgIcon } from 'src/ui/common/atoms/svg-icon';
import { TextInput } from 'src/ui/common/atoms/text-input';
import { TextInput as TechTextInput } from 'src/ui/white-labels/techcontemporary/atoms/text-input';
import { StyledSearch } from './search-input.styles';

interface IProps {
    placeholder: string;
    value: string;
    className?: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onSubmit?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onClear: () => void;
    onBlur?: () => void;
    changeHeight?: boolean;
}

export const SearchInput: React.VFC<IProps> = ({
    className,
    onBlur,
    onSubmit,
    onClear,
    placeholder,
    value,
    onChange,
    changeHeight,
}) => {
    const { isOceanTemplate, isTechContemporary } = useGetUniverseTemplate();
    const handleKeyDown = useCallback(
        (event) => {
            if (onSubmit && (event.code === 'Enter' || event.code === 'NumpadEnter')) {
                onSubmit(event);
            }
        },
        [onSubmit]
    );

    const getSearchSvg = useCallback(() => {
        if (isOceanTemplate) {
            return <SvgIcon variant="regular" icon="search" width={16} color="black" />;
        }
        return <SvgIcon variant="regular" icon="search" width={24} height={24} />;
    }, [isOceanTemplate]);

    return (
        <StyledSearch isTechContemporary={isTechContemporary} className={className}>
            {getSearchSvg()}
            {isTechContemporary ? (
                <TechTextInput
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    onKeyDown={handleKeyDown}
                    changeHeight={changeHeight}
                />
            ) : (
                <TextInput
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    onKeyDown={handleKeyDown}
                    changeHeight={changeHeight}
                />
            )}
            {!!value && <SvgIcon variant="regular" icon="cross" width={16} onClick={onClear} />}
        </StyledSearch>
    );
};